<template>
    <container :class="{
      'pa-0': $vuetify.breakpoint.smAndDown,
      'px-5 py-5': $vuetify.breakpoint.mdAndUp,
    }">
    
    <v-layout justify-space-around>   
        <v-flex xs12 sm10>       
            <v-img :src='require("../../../assets/static/img/img-Blog/Post-3.webp")' alt="imagen principal del articulo"></v-img>   
        </v-flex>  
    </v-layout>

    
        <v-layout align-center justify-center row wrap>
                <v-flex class="articulo" justify-center sm10>
                    <h1>Las 3R de la ropa en las mudanzas</h1>
                    <br>
                    <p>Las mudanzas son una oportunidad para renovarse, cambiar de aire, comenzar una nueva 
                        etapa, cerrar un ciclo o reducirnos para vivir con lo esencial (esta es la tendencia). Son 
                        muchos los efectos que generan un cambio de casa… la ropa es parte importante de las 
                        mudanzas, por eso es bueno preguntarnos ¿que me llevo?</p>
                    <br>
                    <p>Al comenzar a ordenar y embalar siempre, siempre, siempre aparecen mas cosas de las 
                        esperadas. Los roperos o closet se transforman en “portales del multiverso”. Al otro lado 
                        hay prendas que no sabíamos que existían o que pertenecían a mi otro yo. Lo bueno es 
                        que podemos transformarnos en superhéroes si las reutilizamos, reciclamos, donamos o 
                        regalamos.</p>
                    <br>
                    <p>La industria textil es una de las mas contaminantes y sobra evidencia de lo necesario que 
                        es disminuir su producción (y es absolutamente posible).</p>
                    <br>
                    <p>Actualmente hay muchas alternativas para hacerlo. Algunas que me parecen geniales:</p>
                    <br>
                    
                    <h2>Reutilizar</h2> 
                    <br>
                    <p>Alguna vez leí (a modo de ejemplo) que la ruta natural en la vida de una Polera o un Chaleco debiese ser:</p>
                    <br>
                    <p>Para salir -> Para andar en la casa -> Para hacer aseo -> Pijama -> Para sacudir -> Para trapear</p>
                    <br>
                    <p>Agregaría un par de usos antes de que se transforme en un trapo. Aquí algunas ideas:</p>
                        <br>
                        <ul>
                            <li>Transformarla en un Bolsa cool</li>
                            <li>Hacer una cama para para la mascota</li>
                            <li>Armar muñecos (pueden ser regalos perfectos y BBB)</li>
                        </ul>   
                        <br>
                    <p>En YouTube existen muchos tutoriales entretenidos que dan muchas mas ideas para reutilizar tus prendas regalonas..</p>             
                    <br>        

                    <h2>Reciclar</h2>  
                    <br>
                    <p>Por suerte hoy en día hay muchas personas y pymes que se dedican a reciclar los 
                        materiales textiles. Algunas las convierten en hilados que permiten fabricar nuevas 
                        prendas como ECOCITEX o TRAVIESO.</p>
                    <br>
                    <p>Estas opciones permiten darle varias vidas adicionales a la materia prima.</p>
                    <p>Si se trata de un jeans las opciones son mucho mas versátiles y entretenidas.</p>    
                    <br>
                    <h2>Regalar</h2> 
                    <br>
                    <p>Cuando no hay tiempo para el Art Attack, el día de la mudanza se acerca y queda mas de 
                        la mitad por embalar, la mejor alterativa es regalar o donar las cosas. Hay varias
                        instituciones u ONG que reciben la ropa usada, siempre y cuando estén en buenas 
                        condiciones y sea algo que tu también ocuparías.</p>
                    <br>
                    <p>Por ejemplo en COANIQUEM tiene una tienda donde venden las cosas para poder 
                        financiar parte de su obra con los niños quemados.</p>
                    <p>Si definitivamente no queremos deshacernos de nuestras prendas regalonas, sabemos 
                        que seguiremos usandolas y serán parte de la mudanza, procura doblarlas muy bien y 
                        optimiza el embalaje. Una forma practica es meterlas en maletas o bolas de basura (que 
                        también puedes reutilizar si no se rompen). </p>
                    <br>
                    <p>También ahorramos comprando menos cajas y la mudanza será mas liviana.</p>
                    <br>    
                    <h3>Copyright © DuoApp 2022 </h3> 

                    <v-btn @click="retroceder()" style="background-color: #1f97b9; color: #ffffff;">volver</v-btn>
                </v-flex>
        </v-layout>        
    </container>
</template>    
<script>
import { EventBus } from "../../../events.js";
export default {
    data () {
        return{
        }
    },
    methods: {

        retroceder(){
        EventBus.$emit('Retroceder', 1);
      }
    },
    mounted(){
        window.scrollTo(0, 0)
    
    }

}
</script>